import React from 'react';
import Layout from '../../components/Layout';
import SubNavBar from '../../components/SubNavBar/SubNavBar';
import JobNotifications from './JobNotifications';

function action({ store }) {
  const title = store.getState().siteSettings?.data?.siteTitle;
  const description = store.getState().siteSettings?.data?.metaDescription;
  const isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/' };
  }
  return {
    title,
    description,
    component: (
      <Layout>
        <div className={isAuthenticated ? 'subPageMainContainer' : 'withoutPageMainContainer'}>
          {isAuthenticated && <SubNavBar />}
          <JobNotifications />
        </div>
      </Layout>
    ),
  };
}

export default action;
